import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { PoolModel } from '~src/settings/general-settings/components/sections/bridge/types/PoolModel';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ICreateEdgePoolParams {
  displayName: string;
  bridgeSettingsVersion: string;
  siteId: string;
}

export interface ICreateEdgePoolResult extends IResult {
  success?: {
    pool: PoolModel;
    siteID: string;
  };
  error?: {
    errorCode: string;
  };
  bridgeSettingsVersion: string;
}

export class CreateEdgePoolRequest extends Request<ICreateEdgePoolParams, ICreateEdgePoolResult> {
  constructor(params: ICreateEdgePoolParams) {
    super('createEdgePool', params);
  }
}
